/* tslint:disable */

/**
 */
export class Notify {
    id?: number;
    title?: string;
    subject_id?: string;
    subject_data?: string;
    readed?: number;
    notify_type_id?: number;
    company_id?: number;
    created_at?: string;
    updated_at?: string;
}
